/**
 * BiotechLandscape - Process carousel and biotech pattern
 */
(function() {
    'use strict';

    /**
     * Initialize biotech pattern background
     */
    function initBiotechPattern() {
        const container = document.querySelector('.landscape-container');
        if (!container) return;

        const patternUrl = container.dataset.biotechPattern;
        if (patternUrl) {
            document.documentElement.style.setProperty('--biotech-pattern-url', `url('${patternUrl}')`);
        }
    }

    /**
     * Initialize process carousel with pagination (mobile only, below md: 768px)
     */
    function initProcessCarousel() {
        const carouselWrapper = document.querySelector('[data-process-carousel]');
        if (!carouselWrapper) return;

        const carousel = carouselWrapper.querySelector('[data-carousel-container]');
        const pagination = carouselWrapper.querySelector('[data-pagination]');

        if (!carousel || !pagination) return;

        // Only initialize on mobile (below md breakpoint)
        const mobileQuery = window.matchMedia('(max-width: 767px)');

        function setupCarousel() {
            // Clear existing dots
            pagination.innerHTML = '';

            // Only setup if mobile
            if (!mobileQuery.matches) return;

            const steps = carousel.querySelectorAll('.process-step');
            if (steps.length === 0) return;

            let currentIndex = 0;

            // Create pagination dots
            steps.forEach((_, index) => {
                const dot = document.createElement('button');
                dot.className = 'process-pagination-dot' + (index === 0 ? ' active' : '');
                dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
                dot.addEventListener('click', () => scrollTo(index));
                pagination.appendChild(dot);
            });

            const dots = pagination.querySelectorAll('.process-pagination-dot');

            function scrollTo(index) {
                if (steps[index]) {
                    const cardWidth = steps[0].offsetWidth;
                    const gap = 16;
                    carousel.scrollTo({
                        left: index * (cardWidth + gap),
                        behavior: 'smooth'
                    });
                }
            }

            function updatePagination() {
                const scrollLeft = carousel.scrollLeft;
                const cardWidth = steps[0].offsetWidth;
                const gap = 16;
                const newIndex = Math.round(scrollLeft / (cardWidth + gap));

                if (newIndex !== currentIndex && newIndex >= 0 && newIndex < steps.length) {
                    currentIndex = newIndex;
                    dots.forEach((dot, i) => {
                        dot.classList.toggle('active', i === currentIndex);
                    });
                }
            }

            carousel.addEventListener('scroll', updatePagination, { passive: true });
        }

        // Initial setup
        setupCarousel();

        // Re-setup on resize
        mobileQuery.addEventListener('change', setupCarousel);
    }

    /**
     * Initialize on DOM ready
     */
    function init() {
        initBiotechPattern();
        initProcessCarousel();
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Re-initialize if Neos backend updates the content
    if (typeof document.addEventListener === 'function') {
        document.addEventListener('Neos.NodeCreated', init);
        document.addEventListener('Neos.NodeUpdated', init);
    }
})();
